/*🤫
🤫
🤫*/
window.o_global.eventLoader.onLoad(100, () => {
  window.o_util.event.delegate(document as never, "click", ".js_goBack", function goBack(e) {
    const url = this.getAttribute("href");

    e.preventDefault();
    window.history.back();

    if (url) {
      setTimeout(() => {
        window.location = url as never;
      }, 200);
    }
  });
});
